import { render, staticRenderFns } from "./select-min-max.vue?vue&type=template&id=3a473128"
import script from "./select-min-max.vue?vue&type=script&lang=ts"
export * from "./select-min-max.vue?vue&type=script&lang=ts"
import style0 from "./select-min-max.vue?vue&type=style&index=0&id=3a473128&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports